import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class VideoSearchConverter extends CmsConverterService<VideoSearchData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const VIDEO_SEARCH_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, VideoSearchData>>('VideoSearchConverter')

export type VideoSearchData = ConvertedComponentData
